import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from './consent-use-case-actions';
import {exhaustMap, map} from 'rxjs/operators';
import {ConsentUseCaseRestService} from '@core/modules/rest/consent-use-case/consent-use-case-rest.service';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';

@Injectable()
export class ConsentUseCaseEffects {

    constructor(private actions$: Actions, private consentUseCaseRestService: ConsentUseCaseRestService) {
    }

    getAllConsentUseCases$ = createEffect(() => {
            return this.actions$
                .pipe(
                    ofType(fromActions.GetConsentUseCases),
                    exhaustMap((action: ReturnType<typeof fromActions.GetConsentUseCases>) => {
                        return this.consentUseCaseRestService.getConsentUseCases(action.indicationId, action.language, action.languageStyle)
                            .pipe(
                                map((response: ConsentUseCaseBasicModel[]) => fromActions.GetConsentUseCasesSuccess({
                                    consentUseCases: response
                                }))
                            );
                    })
                );
        }
    );
}
